import axios from 'axios';
import { Message } from 'element-ui';

import { API_BASE_URL, DEFAULT_PAGE_SIZE, getAuthToken } from '../config/appConfig';
/**
 * 获取展会列表
 * Method: POST
 * Content-Type: application/x-www-form-urlencoded
 * @param {Object} params - { Hall, Year, Month }
 */
export function getExhibitionList(params) {
  const url = `${API_BASE_URL}/Exhibition/pagingExh`;

  // 构建 form-urlencoded 数据
  const formData = new URLSearchParams();
  // 只有当参数有值时才追加，避免传递 undefined
  if (params.Hall) formData.append('HallId', params.Hall);
  if (params.Year) formData.append('Year', params.Year);
  if (params.Month) formData.append('Month', params.Month);
  if (params.Keyword) formData.append('SearchInput', params.Keyword);

  formData.append('IsHotelRoom', '1') //固定参数，查询设置房态
  formData.append('PageIndex', 1);
  formData.append('PageSize', DEFAULT_PAGE_SIZE);
  return axios.post(url, formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': getAuthToken() // ★ 动态获取 Token
    }
  }).catch(error => {
    console.error('获取展会列表失败:', error);
    // 直接显示错误提示
    Message.error('获取展会列表失败，请稍后重试');
    // 返回包含错误信息的对象
    return {
      success: false,
      error: error,
      data: { Datas: [] }
    };
  });
}
